import React from 'react';
import { createPortal } from 'react-dom';
import { useToast } from './ToastContext';
import Toast from './Toast';
import '../../../styles/Toast.css';

const ToastContainer = () => {
    const { toasts, removeToast } = useToast();

    if (toasts.length === 0) return null;

    return createPortal(
        <div className="toast-container" aria-label="Notifications">
            {toasts.map((toast) => (
                <Toast
                    key={toast.id}
                    id={toast.id}
                    type={toast.type}
                    title={toast.title}
                    message={toast.message}
                    duration={toast.duration}
                    onRemove={removeToast}
                />
            ))}
        </div>,
        document.body
    );
};

export default ToastContainer;